import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SuppliersList from './SuppliersList'

export default function Suppliers() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/suppliers" component={SuppliersList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}